export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/making_bet-67e415695e82957b42eecf1459563046.mp3";